var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSignOutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-switch_off_02"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "switch_off_02",
    "data-name": "switch off 02",
    clipPath: "url(#clip-switch_off_02)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3720",
    "data-name": "Group 3720",
    transform: "translate(0.104 -0.44)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_1",
    "data-name": "Subtraction 1",
    d: "M7.287,13.061A7.105,7.105,0,0,1,0,6.174,7.122,7.122,0,0,1,3.688.068L3.693.063A.414.414,0,0,1,3.914,0a.566.566,0,0,1,.473.289.516.516,0,0,1-.221.688,5.68,5.68,0,0,0-1.3,9.279,6.5,6.5,0,0,0,8.848,0A5.705,5.705,0,0,0,13.561,6.09,5.825,5.825,0,0,0,10.344.971L10.33.965A.427.427,0,0,1,10.082.7a.418.418,0,0,1,.053-.357l0-.016.01-.016a.413.413,0,0,1,.385-.262.439.439,0,0,1,.236.066l.01.008a6.88,6.88,0,0,1,3.795,6.047A7.105,7.105,0,0,1,7.287,13.061Z",
    transform: "translate(1.896 4.94)",
    fill: "#c06c84"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_2",
    "data-name": "Subtraction 2",
    d: "M.5,9.287a.468.468,0,0,1-.5-.5V.5A.468.468,0,0,1,.5,0a.471.471,0,0,1,.51.5V8.783A.475.475,0,0,1,.5,9.287Z",
    transform: "translate(8.679 0.439)",
    fill: "#c06c84"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignOutIcon);
export default __webpack_public_path__ + "static/media/SignOutIcon.1c2c891e903641731a17a6003a08bd52.svg";
export { ForwardRef as ReactComponent };